import { PERIOD_TYPE, defaultFilters } from "./health-clients-constants";

export const pick = (row, ...keys) => {
  for (const key of keys) {
    if (row[key] !== undefined && row[key] !== null) return row[key];
  }
  return undefined;
};

export const toNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

export const formatDate = (value) => {
  if (!value) return "";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("ru-RU");
};

export const formatTime = (value) => {
  if (!value) return "";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" });
};

export const formatNumber = (value) => {
  const n = toNumber(value);
  if (n == null) return "";
  return String(n);
};

export const formatBool = (value) => {
  const n = toNumber(value);
  if (n == null) return "";
  return n ? "✓" : "";
};

export const normalizeClientRow = (row) => {
  const idClient = toNumber(pick(row, "idClient", "IdClient"));
  const idZal = toNumber(pick(row, "idZal", "IdZal")) ?? 0;
  const zalIdStr = toNumber(pick(row, "zalIdStr", "ZalIdStr")) ?? 0;
  const idClientStrUsl = toNumber(pick(row, "idClientStrUsl", "IdClientStrUsl")) ?? 0;

  return {
    key:
      idZal || zalIdStr || idClientStrUsl
        ? `${idZal}-${zalIdStr}-${idClient}-${idClientStrUsl}`
        : String(idClient ?? ""),
    idZal,
    zalIdStr,
    idClientStrUsl,
    fdate: pick(row, "fdate", "Fdate"),
    dateV: pick(row, "dateV", "DateV"),
    isPred: toNumber(pick(row, "isPred", "IsPred")) ?? 0,
    isOk: toNumber(pick(row, "isOk", "IsOk")) ?? 0,
    namePut: pick(row, "namePut", "NamePut") ?? "",
    idClient,
    extraId: pick(row, "extraId", "ExtraId") ?? "",
    dateReg: pick(row, "dateReg", "DateReg"),
    name: pick(row, "name", "Name") ?? "",
    sotrName: pick(row, "sotrName", "SotrName") ?? "",
    dateBeg: pick(row, "dateBeg", "DateBeg"),
    dateEnd: pick(row, "dateEnd", "DateEnd"),
    days: pick(row, "days", "Days"),
    dateVipiska: pick(row, "dateVipiska", "DateVipiska"),
    komment: pick(row, "komment", "Komment") ?? "",
    dateVizit: pick(row, "dateVizit", "DateVizit"),
    daysFact: pick(row, "daysFact", "DaysFact"),
    keyCardShort: pick(row, "keyCardShort", "KeyCardShort") ?? "",
    deposit: pick(row, "deposit", "Deposit"),
    isNotSk: toNumber(pick(row, "isNotSk", "IsNotSk")) ?? 0,
    osnTxt: pick(row, "osnTxt", "OsnTxt") ?? "",
    age: pick(row, "age", "Age"),
    dateBird: pick(row, "dateBird", "DateBird"),
    idDoc: pick(row, "idDoc", "IdDoc"),
    idStr: pick(row, "idStr", "IdStr"),
    tovName: pick(row, "tovName", "TovName") ?? "",
    factIsOk: toNumber(pick(row, "factIsOk", "FactIsOk")) ?? 0,
    zalName: pick(row, "zalName", "ZalName") ?? "",
    nameLech: pick(row, "nameLech", "NameLech") ?? "",
    ssgName: pick(row, "ssgName", "SsgName") ?? "",
    dDateBeg: pick(row, "dDateBeg", "DDateBeg"),
    dDateEnd: pick(row, "dDateEnd", "DDateEnd"),
    docnum: pick(row, "docnum", "Docnum")
  };
};

export const CLIENT_STATUS = {
  IN: "in",
  OUT: "out",
  WAIT: "wait"
};

export const CLIENT_STATUS_META = {
  [CLIENT_STATUS.IN]: { label: "В санатории", className: "health-clients__status--in" },
  [CLIENT_STATUS.OUT]: { label: "Выписан", className: "health-clients__status--out" },
  [CLIENT_STATUS.WAIT]: { label: "Ожидает", className: "health-clients__status--wait" }
};

export const getClientStatus = (row) => {
  if (row?.dateVipiska) return CLIENT_STATUS.OUT;
  const beg = row?.dateBeg ? new Date(row.dateBeg) : null;
  if (beg && !Number.isNaN(beg.getTime())) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    beg.setHours(0, 0, 0, 0);
    if (beg > today) return CLIENT_STATUS.WAIT;
  }
  return CLIENT_STATUS.IN;
};

export const formatCardNo = (row) => {
  const extra = String(row?.extraId || "").trim();
  if (extra) return extra.startsWith("№") ? extra : `№${extra}`;
  const card = String(row?.keyCardShort || "").trim();
  if (card) return card.startsWith("№") ? card : `№${card}`;
  if (row?.idClient != null) return `№${String(row.idClient).padStart(4, "0")}`;
  return "";
};

export const formatPlacement = (row) => {
  const num = row?.docnum;
  if (num == null || num === "") return "";
  const text = String(num);
  return text.startsWith("№") ? text : `№${text}`;
};

const isIsoDate = (value) =>
  typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value);

const PERIOD_TYPE_VALUES = new Set(Object.values(PERIOD_TYPE));

const FILTER_URL_KEYS = ["periodType", "dateBeg", "dateEnd", "inComplex", "idSotr", "name"];

export const filtersToSearchParams = (filters) => {
  const params = new URLSearchParams();
  const base = defaultFilters();
  const periodType = Number(filters?.periodType);
  if (PERIOD_TYPE_VALUES.has(periodType) && periodType !== base.periodType) {
    params.set("periodType", String(periodType));
  }
  if (isIsoDate(filters?.dateBeg)) params.set("dateBeg", filters.dateBeg);
  if (isIsoDate(filters?.dateEnd)) params.set("dateEnd", filters.dateEnd);
  if (filters?.onlyInComplex) params.set("inComplex", "1");
  if (Number(filters?.idSotr) > 0) params.set("idSotr", String(Number(filters.idSotr)));
  const name = typeof filters?.name === "string" ? filters.name.trim() : "";
  if (name) params.set("name", name);
  return params;
};

export const filtersFromSearchParams = (searchParams) => {
  const params =
    searchParams instanceof URLSearchParams
      ? searchParams
      : new URLSearchParams(searchParams || "");
  if (!FILTER_URL_KEYS.some((key) => params.has(key))) return null;

  const base = defaultFilters();
  const periodType = Number(params.get("periodType"));
  const idSotr = Number(params.get("idSotr"));
  return {
    periodType: PERIOD_TYPE_VALUES.has(periodType) ? periodType : base.periodType,
    dateBeg: isIsoDate(params.get("dateBeg")) ? params.get("dateBeg") : null,
    dateEnd: isIsoDate(params.get("dateEnd")) ? params.get("dateEnd") : null,
    onlyInComplex: params.get("inComplex") === "1",
    idSotr: Number.isFinite(idSotr) && idSotr > 0 ? idSotr : 0,
    name: params.get("name") ?? ""
  };
};

export const filtersSearchEquals = (a, b) =>
  filtersToSearchParams(a).toString() === filtersToSearchParams(b).toString();
